// extracted by mini-css-extract-plugin
export default {"ie-banner-index":"1000000","container":"styles_container__L0KZP","copy":"styles_copy__ELIzF","close":"styles_close__jFyyA"};